import { CodecUtils } from 'common/utils/codec-utils';

export enum TrialPeriodUnit {
  Unknown = 'Unknown',
  Day = 'Day',
  Month = 'Month',
}

export const TrialPeriodUnitC = CodecUtils.createEnumCodec<TrialPeriodUnit>(TrialPeriodUnit, 'TrialPeriodUnit');
